import ApiService from '@services/api.service'

export default {
    resource: 'get-latest-version',

    getVersion() {
        return ApiService.get(`/${this.resource}`)
    }
}